import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import router from './router'
import store from './store'
// import '@/assets/font/font.css'
import App from './App.vue'
import * as echarts from 'echarts'
import axios from 'axios'
import vue3SeamlessScroll from "vue3-seamless-scroll";
const app = createApp(App)
app.provide('$echarts',echarts);
// app.provide('$axios',axios)
app.config.globalProperties.$echarts = echarts
app.use(router).use(store).use(ElementPlus).use(vue3SeamlessScroll).mount("#app");
/***********************echart 挂载 START*******************************/
// echarts 挂载到 Vue实例中
// 注意：app.config.globalProperties 和 app.provide('$echarts', echarts) 二选一即可
// Vue.prototype.$echarts = echarts; // vue2的挂载方式
// app.config.globalProperties.$echarts = echarts; // vue3的挂载方式（一个用于注册能够被应用内所有组件实例访问到的全局属性的对象。）
// app.provide('$echarts', echarts); // vue3采用provide, inject方式使用
 